import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class EmailInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'Email',
      label: label || 'Email',
      waitForNoLoaders: waitForNoLoaders || false,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.userInformation.email
  }
}
